import WPCliRepositoryInterface, {
  InstallWPInterface,
  TemporaryWPCredentialsInterface,
} from '@/services/WPCli/interfaces';
import { AxiosInstance } from 'axios';

export default class WPCliRepository implements WPCliRepositoryInterface {
  constructor(
    private readonly axios: AxiosInstance,
  ) {
  }

  public async getWPStatus(websiteId: number): Promise<void> {
    await this.axios.get(`/wp-cli/${websiteId}/check`);
  }

  public async installWp(data: InstallWPInterface): Promise<void> {
    await this.axios.post('/wp-cli/install', data);
  }

  public async saveTempCredentials(data: TemporaryWPCredentialsInterface): Promise<void> {
    await this.axios.post('/wp-cli/credentials', data);
  }

  public async uninstallWp(websiteId: number): Promise<void> {
    await this.axios.delete(`/wp-cli/${websiteId}`);
  }
}
